import React from "react";

export default function Pricing({ onStartTrial }) {
  return (
    <section className="landing-section">
      <div className="landing-section-heading">
        <div className="landing-eyebrow">Pricing</div>
        <h2>Simple pricing. No surprises.</h2>
        <p>
          Start free for 7 days, explore the full workflow, then continue on
          an affordable plan built for active traders.
        </p>
      </div>

      <div className="landing-pricing-wrap">
        <article className="landing-pricing-card">
          <div className="landing-pricing-badge">Free Access</div>
          <h3>Trial Plan</h3>
          <div className="landing-price-row">
            <span className="landing-price">Free</span>
            <span className="landing-price-meta">for 7 days</span>
          </div>
          <p className="landing-pricing-copy">
            Explore the full workflow and decide if Spike Hunter Online fits
            the way you trade — no payment required to start.
          </p>
          <ul className="landing-pricing-list">
            <li>7-day full platform access</li>
            <li>Live dashboard included</li>
            <li>Zone-first workflow preview</li>
          </ul>
        </article>

        <article className="landing-pricing-card landing-pricing-card-featured">
          <div className="landing-pricing-badge">Most Popular</div>
          <h3>Monthly Plan</h3>
          <div className="landing-price-row">
            <span className="landing-price">$10</span>
            <span className="landing-price-meta">/ month after trial</span>
          </div>
          <p className="landing-pricing-copy">
            Continue with full access on a low monthly plan built for traders
            who value a clean, structured charting workflow.
          </p>
          <ul className="landing-pricing-list">
            <li>Unlimited platform access</li>
            <li>Real-time zone detection</li>
            <li>Instant price alerts</li>
            <li>Boom &amp; Crash optimized workflow</li>
          </ul>
          <button type="button" className="landing-primary-button" onClick={onStartTrial}>
            Start Your Free Trial
          </button>
        </article>
      </div>
    </section>
  );
}
